import type { LayerSpecification, VectorSourceSpecification } from 'maplibre-gl';
import type { CatalogueTiles } from './useCatalogueTiles';

/** The ceiling the archives are built to. MapLibre then overzooms past it, and does not
 *  request a tile that was never built. */
export const ARCHIVE_MAX_ZOOM = 14;

const FILL_OPACITY = 0.25;

export const catalogueSource = ({ tileUrl }: CatalogueTiles): VectorSourceSpecification => ({
    type: 'vector',
    tiles: [tileUrl],
    minzoom: 0,
    maxzoom: ARCHIVE_MAX_ZOOM,
});

export type OverlayTarget = {
    sourceId: string;
    sourceLayer: string;
};

/** A dataset that is not areas brings its own builder to the registry. */
export const areaLayers =
    (colour: string) =>
    ({ sourceId, sourceLayer }: OverlayTarget): LayerSpecification[] =>
        [
            {
                id: `${sourceId}-fill`,
                type: 'fill',
                source: sourceId,
                'source-layer': sourceLayer,
                paint: { 'fill-color': colour, 'fill-opacity': FILL_OPACITY },
            },
            {
                id: `${sourceId}-outline`,
                type: 'line',
                source: sourceId,
                'source-layer': sourceLayer,
                paint: { 'line-color': colour, 'line-width': 1 },
            },
        ];
